
export default [
  {
      "id": 1,
      "name": "仕訳の作り方",
      "sort": 1
  },
  {
      "id": 2,
      "name": "商品の仕入れ（三分法）",
      "sort": 2
  },
  {
      "id": 3,
      "name": "商品の売上げ（三分法）",
      "sort": 3
  },
  {
      "id": 4,
      "name": "掛け取引",
      "sort": 4
  },
  {
      "id": 5,
      "name": "クレジット払いによる売上げ",
      "sort": 5
  },
  {
      "id": 6,
      "name": "商品券による売上げ",
      "sort": 6
  },
  {
      "id": 7,
      "name": "返品",
      "sort": 7
  },
  {
      "id": 8,
      "name": "諸掛り",
      "sort": 8
  },
  {
      "id": 9,
      "name": "前払金と前受金",
      "sort": 9
  },
  {
      "id": 10,
      "name": "消費税",
      "sort": 10
  },
  {
      "id": 11,
      "name": "現金",
      "sort": 11
  },
  {
      "id": 12,
      "name": "現金過不足",
      "sort": 12
  },
  {
      "id": 13,
      "name": "普通預金と定期預金",
      "sort": 13
  },
  {
      "id": 14,
      "name": "当座預金",
      "sort": 14
  },
  {
      "id": 15,
      "name": "当座借越",
      "sort": 15
  },
  {
      "id": 16,
      "name": "小口現金",
      "sort": 16
  },
  {
      "id": 17,
      "name": "約束手形",
      "sort": 17
  },
  {
      "id": 18,
      "name": "電子記録債権（債務）",
      "sort": 18
  },
  {
      "id": 19,
      "name": "貸付金と借入金",
      "sort": 19
  },
  {
      "id": 20,
      "name": "手形貸付金と手形借入金",
      "sort": 20
  },
  {
      "id": 21,
      "name": "仮払金",
      "sort": 21
  },
  {
      "id": 22,
      "name": "仮受金",
      "sort": 22
  },
  {
      "id": 23,
      "name": "立替金",
      "sort": 23
  },
  {
      "id": 24,
      "name": "給料の支払い",
      "sort": 24
  },
  {
      "id": 25,
      "name": "貸倒引当金の設定",
      "sort": 25
  },
  {
      "id": 26,
      "name": "貸倒れの処理",
      "sort": 26
  },
  {
      "id": 27,
      "name": "償却債権取立益",
      "sort": 27
  },
  {
      "id": 28,
      "name": "有形固定資産の購入",
      "sort": 28
  },
  {
      "id": 29,
      "name": "減価償却",
      "sort": 29
  },
  {
      "id": 30,
      "name": "有形固定資産の売却",
      "sort": 30
  },
  {
      "id": 31,
      "name": "未払金と未収入金",
      "sort": 31
  },
  {
      "id": 32,
      "name": "有形固定資産の賃借",
      "sort": 32
  },
  {
      "id": 33,
      "name": "株式会社の設立",
      "sort": 33
  },
  {
      "id": 34,
      "name": "増資",
      "sort": 34
  },
  {
      "id": 35,
      "name": "消耗品",
      "sort": 35
  },
  {
      "id": 36,
      "name": "通信費と租税公課",
      "sort": 36
  },
  {
      "id": 37,
      "name": "収益・費用の未収・未払い",
      "sort": 37
  },
  {
      "id": 38,
      "name": "収益・費用の前受け・前払い",
      "sort": 38
  },
  {
      "id": 39,
      "name": "訂正仕訳",
      "sort": 39
  },
  {
      "id": 40,
      "name": "小口現金出納帳",
      "sort": 40
  },
  {
      "id": 41,
      "name": "伝票",
      "sort": 41
  },
  {
      "id": 42,
      "name": "売上原価の算定",
      "sort": 42
  },
  {
      "id": 43,
      "name": "法人税等の計上",
      "sort": 43
  },
  {
      "id": 44,
      "name": "勘定の締め切り",
      "sort": 44
  },
  {
      "id": 45,
      "name": "剰余金の配当と処分",
      "sort": 45
  }
]